/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { VehicleIconLinkVehicleFragmentDoc } from '../../../../../alert-cards-common/src/lib/VehicleIconLink/vehicleIconLink.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { DriverIconLinkEmployeeFragmentDoc } from '../DriverIconLink/driverIconLink.hook'
export type DefaultMetaNewAlertEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  firstName: string | null
  lastName: string | null
}

export type DefaultMetaNewAlertVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  label: number | null
}

export const DefaultMetaNewAlertEmployeeFragmentDoc = gql`
    fragment DefaultMetaNewAlertEmployee on Employee {
  ...DriverIconLinkEmployee
}
    ${DriverIconLinkEmployeeFragmentDoc}`
export const DefaultMetaNewAlertVehicleFragmentDoc = gql`
    fragment DefaultMetaNewAlertVehicle on Vehicle {
  ...VehicleIconLinkVehicle
}
    ${VehicleIconLinkVehicleFragmentDoc}`
